import { z } from "zod";
//#region src/operator-cert.schemas.ts
/**
* Zod schemas for the operator-cert mTLS bootstrap path (Plan 14).
*
* Used by the CP release-engine controller to validate the inbound
* `CertSignRequest` body, and to runtime-check the bootstrap JWT claims
* after JWS verification.
*/
const CertSignRequestSchema = z.object({ csr: z.string().min(1) }).strict();
const CertSignResponseSchema = z.object({
	cert: z.string().min(1),
	chain: z.string().min(1),
	expiresAt: z.string().min(1),
	fingerprint: z.string().regex(/^[0-9a-f]{64}$/)
}).strict();
const OperatorBootstrapClaimsSchema = z.object({
	scope: z.literal("operator-bootstrap"),
	sub: z.string().min(1),
	aud: z.literal("cert-sign"),
	iat: z.number().int().nonnegative(),
	exp: z.number().int().positive(),
	jti: z.string().min(1)
}).strict();
//#endregion
export { CertSignRequestSchema, CertSignResponseSchema, OperatorBootstrapClaimsSchema };

//# sourceMappingURL=operator-cert.schemas.js.map